import { useState } from 'react';
import { Send, X } from 'lucide-react';

export default function FloatingContact() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {isOpen && (
        <div className="absolute bottom-16 right-0 mb-2 bg-white rounded-lg shadow-lg p-4 w-64 transform transition-all duration-200 ease-out">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-semibold text-gray-900">Contact Us</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <a
            href="https://t.me/NextAPIAI"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 text-gray-600 hover:text-blue-600 transition-colors"
          >
            <Send className="h-5 w-5" />
            <span>Chat on Telegram</span>
          </a>
        </div>
      )}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-lg transition-all duration-200 ${isOpen ? 'rotate-180' : ''
          }`}
      >
        <Send className="h-6 w-6" />
      </button>
    </div>
  );
}